'use es6';

import { GMAIL, OUTLOOK365 } from './EmailClientTypes';
import { GOOGLE_FREE, GOOGLE_APPS, OUTLOOK365 as OUTLOOK_365 } from './EmailProviderTypes';
export default {
  [GMAIL]: {
    key: 'gmail',
    serviceType: 'google',
    providerTypes: [GOOGLE_FREE, GOOGLE_APPS]
  },
  [OUTLOOK365]: {
    key: 'outlook365',
    serviceType: 'office365',
    providerTypes: [OUTLOOK_365]
  }
};